module.exports = __webpack_public_path__ + "img/sparcs_darkgray.46ae669a.png";